import { Preferences } from '@capacitor/preferences';
import { inject, Injectable } from '@angular/core';
import { LoginUser } from '../models/user';
import { RefreshTokenResponse } from '../models/token-req-res';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  constructor() { }

  // private access methods
  private async setLocalData(key: string, data: any) {
    await Preferences.set({ key: key, value: JSON.stringify(data)});
  }
  private async getLocalData(key: string) {
    // return JSON.parse(this.localStorage.get(key));
    const { value } = await Preferences.get({ key: key });
    return (value ?? '') != '' ? JSON.parse(value ?? '') : '';
  }
  private async deleteLocalData(key: string) {
    await Preferences.remove({ key: key });
  }
  // data specific public methods

  // Logged In User
  async setLoggedinUserData(userData: LoginUser) {
    await this.setLocalData('user', userData);
  }
  async getLoggedinUserData(): Promise<LoginUser> {
    return await this.getLocalData('user');
  }
  async deleteLoggedinUserData() {
    await this.deleteLocalData('user');
  }
  async updateAccessToken(newTokens: RefreshTokenResponse) {
    const user = await this.getLoggedinUserData();
    if (user) {
      user.userSecurityToken = newTokens.accessToken;
      user.userRefreshToken = newTokens.refreshToken;
      await this.setLoggedinUserData(user);
    }
  }

  // E-Sign Return URL
  async setEsignReturnUrl(url: string) {
    await this.setLocalData('esign_return_url', url);
  }
  async getEsignReturnUrl(): Promise<string> {
    return await this.getLocalData('esign_return_url');
  }
  async deleteEsignReturnUrl() {
    await this.deleteLocalData('esign_return_url');
  }
}

